"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseTextAndHighlightKeywords = exports.parseTextAndHighlightMultipleKeywords = exports.parseHTMLText = exports.parseQueryString = void 0;
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var parseQueryString = function parseQueryString(queryString) {
  if (queryString === 0 || queryString === undefined || queryString === '') {
    return {};
  }

  var params = {}; // Split into key/value pairs

  var queries = queryString.slice(1).split("&"); // Convert the array of strings into an object

  for (var idx = 0; idx < queries.length; idx++) {
    var temp = queries[idx].split('=');
    params[temp[0]] = temp[1] === 'null' ? null : temp[1];
  }

  return params;
}; //This function parses text containing HTML entities/numbers by retrieving the text from an HTML textarea.


exports.parseQueryString = parseQueryString;

var parseHTMLText = function parseHTMLText(titleText) {
  var txt = document.createElement("textarea");
  txt.innerHTML = titleText;
  return txt.value;
}; // used for highlight keywords in searched text


exports.parseHTMLText = parseHTMLText;

var parseTextAndHighlightMultipleKeywords = function parseTextAndHighlightMultipleKeywords(text) {
  var keywords = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var newText = text;

  if (text && keywords && keywords.length > 0) {
    keywords.forEach(function (keyword) {
      if (keyword) {
        newText = newText.replace(new RegExp('(' + keyword + ')', 'igm'), '<span class="highlighted">$1</span>'); // newText = (!newText.startsWith("<") ? "<p>" + newText + "</p>" : newText).replace(/(>[^<]+)/igm,
        //     (result) => result.replace(new RegExp("(" + keyword + ")", "igm"), "<span class='highlighted'>$1</span>")
        // );
      }
    });
  }

  return newText;
}; // used for highlight keywords in searched text


exports.parseTextAndHighlightMultipleKeywords = parseTextAndHighlightMultipleKeywords;

var parseTextAndHighlightKeywords = function parseTextAndHighlightKeywords(text, keyword) {
  return text.replace(new RegExp('(' + keyword + ')', 'igm'), '<span class="highlighted">$1</span>');
};

exports.parseTextAndHighlightKeywords = parseTextAndHighlightKeywords;